import { getCurrentInstance } from "vue";

export const useMessage = () => {
  const vm = getCurrentInstance();
  if (!vm) throw new Error("must be called in setup");
  return vm.proxy.$message;
};
